const getActivePillStyle = ({ palette }) => ({
  border: 'none',
  outline: 'none',
  background: palette.themeLighterAlt, // #eff6fc
  color: palette.neutralPrimary, // #323130
  fontFamily: '"Segoe UI"',
  fontWeight: '600',
});

const getFocusAfterPillStyle = ({ palette }) => ({
  border: `1px solid ${palette.neutralSecondary}`, // #6505e5c
  bottom: '1px',
  content: '""',
  left: '1px',
  outline: '1px solid transparent',
  position: 'absolute',
  right: '1px',
  top: '1px',
});

export const pillControlStyle = ({ palette }) => {
  const activePillStyle = getActivePillStyle({ palette });
  const focusAfterPillStyle = getFocusAfterPillStyle({ palette });
  return ({
    '&': { // .nav-pills
      '&>li>a': {
        border: 'none',
        background: palette.neutralLighter, // #f3f2f1
        minWidth: '123px',
        height: '40px',
        color: palette.neutralPrimary, // #323130
        textAlign: 'center',
        fontFamily: '"Segoe UI"',
      },
      '&>li>a:hover': activePillStyle,
      '&>li.active>a': activePillStyle,
      '&>li.active>a:hover': activePillStyle,
      '&>li.active>a:focus': activePillStyle,
      '&>li>a:focus:after': focusAfterPillStyle,
      '&>li:first-child>a': {
        border: 'none',
        color: palette.neutralPrimary, // #323130
      },
      '&>li:last-child>a': {
        border: 'none',
      },
      '&.action-list strong': {
        fontWeight: '600',
      },
    },
  });
};
